{
	"emptyProductFeatureForm": {
		"title": "Nenhum modelo de funcionalidade selecionado",
		"description": "Selecione um modelo personalizado de informações do produto. Para criar um novo modelo acesse a página de",
		"link": "modelos de funcionalidade de produto."
	}
}
